"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function InspectorFinder() {
  const { t } = useLanguage();
  return (
    <section className="bg-[#064e3b] text-white py-12 px-8 rounded-xl my-12">
      <h3 className="text-2xl font-bold mb-6 text-center">{t("blog.codes.inspectorHeading")}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div>
          <p className="text-white/90 leading-relaxed text-sm">
            {t("blog.codes.inspectorText")}
          </p>
        </div>
        <div className="space-y-3">
          <a
            href="https://www.miamidade.gov/building/notice-of-acceptance-search.asp"
            target="_blank"
            rel="noopener noreferrer"
            className="block text-center bg-[#fbbf24] text-[#064e3b] font-bold px-5 py-3 rounded-lg hover:bg-[#fefce8] transition whitespace-nowrap"
          >
            Search Miami-Dade NOA Database
          </a>
          <a
            href="https://www.myfloridalicense.com/wv11.asp?boardid=0&professionid=0"
            target="_blank"
            rel="noopener noreferrer"
            className="block text-center bg-[#fbbf24] text-[#064e3b] font-bold px-5 py-3 rounded-lg hover:bg-[#fefce8] transition whitespace-nowrap"
          >
            Verify FL Contractor License
          </a>
          <a
            href="https://www.miamidade.gov/global/building/permits.page"
            target="_blank"
            rel="noopener noreferrer"
            className="block text-center bg-[#fbbf24] text-[#064e3b] font-bold px-5 py-3 rounded-lg hover:bg-[#fefce8] transition whitespace-nowrap"
          >
            Check Permit Records
          </a>
        </div>
      </div>
    </section>
  );
}